import { atom } from "jotai";

import { parsePage } from "@moment/api-collab/markdown";
import { Logger } from "@moment/logging";

import {
	PRIMARY_AGENTS_MD_PAGE_ID,
	primaryAgentInstructionFilePath,
} from "../document/agents-md.atom";
import { exists, readTextFile } from "../filesystem";

const logger = new Logger("load-agents-md-collab");

/**
 * Reads AGENTS.md from disk and returns its ProseMirror doc JSON, or null
 * if the file doesn't exist. Used by $captureCollabInitSnapshot to include
 * AGENTS.md in the collab snapshot even if the editor state hasn't been
 * lazily loaded yet.
 */
export const $readAgentsMdDocFromDisk = atom(
	null,
	async (_get, _set, documentPath: string): Promise<{ pageId: string; doc: any } | null> => {
		const agentsMdPath = primaryAgentInstructionFilePath(documentPath);

		const fileExists = await exists(agentsMdPath);
		if (!fileExists) {
			logger.debug("No AGENTS.md on disk", { agentsMdPath });
			return null;
		}

		const content = await readTextFile(agentsMdPath);
		const { doc } = parsePage(content);

		logger.debug("Read AGENTS.md from disk for collab snapshot", { agentsMdPath });
		return { pageId: PRIMARY_AGENTS_MD_PAGE_ID, doc };
	}
);
$readAgentsMdDocFromDisk.debugLabel = "readAgentsMdDocFromDisk";
